// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071008/js/" + chunkId + "." + {"44":"a6453e6d","225":"e1442336","481":"06a2a2b4","486":"7488d701","770":"bbb61ac7"}[chunkId] + ".0.7523040481783342.chunk.js";
};